if (!customElements.get('product-benefits-timeline')) {
  customElements.define('product-benefits-timeline', class ProductBenefitsTimeline extends HTMLElement {
    constructor() {
      super();

      this.progressBarAnimationDuration = 5000;
      this.progressBarJumpAnimationDuration = 500;
      
      this.desktopTimelineItems = this.querySelectorAll('.container-desktop li');
      this.progressBar = this.querySelector('.progress .bar');
      this.mobileTimelineItems = this.querySelectorAll('.container-mobile li');
      this.progressBarMobile = this.querySelector('.progress .bar-mobile');
      this.panelCount = this.desktopTimelineItems.length;
      this.animationDesktop = null;
      this.animationMobile = null;
      this.animationStep = 0;
      this.isAnimating = true;

      this.initBenefitsTimeline();
    }

    initBenefitsTimeline() {
      let mouseOutTimeout = null;
      const that = this;
      this.desktopTimelineItems.forEach((item, index) => {
        item.addEventListener('mouseover', function (e) {
          if (mouseOutTimeout) {
            clearTimeout(mouseOutTimeout);
          }
          that.progressBarJumpToStep(index);
        });

        item.addEventListener('mouseout', function (e) {
          if (mouseOutTimeout) {
            clearTimeout(mouseOutTimeout);
          }
          mouseOutTimeout = setTimeout(() => {
            that.progressBarAnimate();
          }, 2000);
        });
      });

     this.progressBarAnimate();
    }

    async progressBarAnimate() {
      this.isAnimating = true;
      while (this.isAnimating) {
        await this.progressBarAnimateStep();
      }
    }

    async progressBarAnimateStep() {
      if (this.animationDesktop) {
        this.animationDesktop.cancel();
      }
      if (this.animationMobile) {
        this.animationMobile.cancel();
      }

      if (this.animationStep >= this.panelCount) {
        // progress bar goes back to 0
        this.animationDesktop = this.progressBar.animate({
          width: [getComputedStyle(this.progressBar).width, 0]
        }, {
          duration: this.progressBarJumpAnimationDuration,
          fill: 'forwards'
        });
        this.animationMobile = this.progressBarMobile.animate({
          height: [getComputedStyle(this.progressBarMobile).height, 0]
        }, {
          duration: this.progressBarJumpAnimationDuration,
          fill: 'forwards'
        });
      } else {
        // progress bar goes forward from one point to another
        const stylePercentageStart = Math.round(this.animationStep / this.panelCount * 100);
        const stylePercentageEnd = Math.round((this.animationStep + 1) / this.panelCount * 100);

        this.animationDesktop = this.progressBar.animate({
          width: [stylePercentageStart + '%', stylePercentageEnd + '%']
        }, {
          duration: this.progressBarAnimationDuration,
          fill: 'forwards'
        });
        this.animationMobile = this.progressBarMobile.animate({
          height: [stylePercentageStart + '%', stylePercentageEnd + '%']
        }, {
          duration: this.progressBarAnimationDuration,
          fill: 'forwards'
        });

        this.desktopTimelineItems.forEach((item, index) => {
          if (index === this.animationStep) {
            item.classList.add('selected');
          } else {
            item.classList.remove('selected');
          }
        });
        this.mobileTimelineItems.forEach((item, index) => {
          if (index === this.animationStep) {
            item.classList.add('selected');
          } else {
            item.classList.remove('selected');
          }
        });
      }

      this.animationStep++;
      if (this.animationStep > this.panelCount) {
        this.animationStep = 0;
      }

      try {
        await Promise.all([this.animationDesktop.finished, this.animationMobile.finished]);
      } catch (ex) {}
      this.animationDesktop = null;
      this.animationMobile = null;

    }

    async progressBarJumpToStep(step) {
      this.isAnimating = false;
      let oldAnimationDesktop;
      let oldAnimationMobile;
      if (this.animationDesktop) {
        oldAnimationDesktop = this.animationDesktop;
        this.animationDesktop.pause();
      }
      if (this.animationMobile) {
        oldAnimationMobile = this.animationMobile;
        this.animationMobile.pause();
      }
      this.animationStep = step + 1;

      const stylePercentage = Math.round((step + 1) / this.panelCount * 100);
      this.animationDesktop = this.progressBar.animate({
        width: [getComputedStyle(this.progressBar).width, stylePercentage + '%']
      }, {
        duration: this.progressBarJumpAnimationDuration,
        fill: 'forwards'
      });
      this.animationMobile = this.progressBarMobile.animate({
        height: [getComputedStyle(this.progressBarMobile).height, stylePercentage + '%']
      }, {
        duration: this.progressBarJumpAnimationDuration,
        fill: 'forwards'
      });

      this.desktopTimelineItems.forEach((item, index) => {
        if (index === step) {
          item.classList.add('selected');
        } else {
          item.classList.remove('selected');
        }
      });
      this.mobileTimelineItems.forEach((item, index) => {
        if (index === step) {
          item.classList.add('selected');
        } else {
          item.classList.remove('selected');
        }
      });
      
      try {
        await Promise.all([this.animationDesktop.finished, this.animationMobile.finished]);
      } catch (ex) {}
      this.animationDesktop = null;
      this.animationMobile = null;
      if (oldAnimationDesktop) {
        oldAnimationDesktop.cancel();
      }
      if (oldAnimationMobile) {
        oldAnimationMobile.cancel();
      }
    }
  });
}
